<template>
    <div class="email-verification">
        <div v-if="id != null">
            <h2 class="view__title">{{ __('Verify Your Email Address') }}</h2>

            {{ __('Before proceeding, please check your email for a verification link.') }}
            {{ __('If you did not receive the email') }}, <a href="#" v-on:click="handleEmailResend">{{ __('click here to request another') }}</a>.
        </div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            this.init();
        },
        data: function () {
            return {
                id: this.$route.params.id || null
            }
        },
        methods: {
            handleEmailResend: function() {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/email/resend/' + this.id).then(function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'success',
                            this.__('We have resent your verification e-mail!')
                    );

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            init: function () {
                eventBus.$emit('show-loader');

                let routeQuery = '';
                let routeQueryObj = this.$route.query;
                Object.keys(this.$route.query).map(function(objectKey, index) {
                    routeQuery = (routeQuery == '' ? '?' : (routeQuery + '&')) + objectKey + '=' + routeQueryObj[objectKey];
                });

                this.$http.get(this.apiUrl + '/email/verify/' + this.id + routeQuery).then(function (response) {
                    this.loginUser(response.body);

                    eventBus.$emit(
                            'show-alert',
                            'success',
                            this.__('Your account has been successfully verified.')
                    );

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit('hide-loader');
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EmailVerification.vue